
































































































import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
import Api from '@/mixins/api';
import Helpers from '@/mixins/helpers';
import FieldText from '@/components/dumb/FieldText.vue';
import Validation from '../mixins/validation';
import Analytics from '@/mixins/analytics';
export default Vue.extend({
	name: 'ReferenceCode', 
	components: {
		FieldText
	}, 
	data: function(){
		return {
			isFormValid: false, 
			isProcessing: false,
			emailRequired: false,
			emailError: false,
			invalid: false,
			hasSetEmail: false,
			errorMsg: '', 
			form: {
				email: '',
				code: ''
			}
		};
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			tpr(): any { return this.$store.state.tpr },
			promoCode(): any { return this.$store.state.promoCode },
			vehicle(): any { return this.$store.state.vehicle },
			finance(): any { return this.$store.state.finance },
			dealer(): any { return this.$store.state.dealer },
			customer(): any { return this.$store.state.customer }
		}), 
		// hasDescription(): boolean {
		// 	return this.promoCode.SysDesc || this.promoCode.Description;
		// },
		promoValue(): string {
			return this.promoCode.PromoValue ? Helpers.getFormattedPrice(this.promoCode.PromoValue) : '';
		}, 
		emailRules(): Array<Function> {
			return [Validation.isEmail];
		}, 
	},
	methods: {
		handleFieldUpdate(fieldName: string, isValid: boolean): void {
			// field.isValid = value;
			// todo analytics?
		},
		handleAddClick(): void {
			this.isProcessing = true;
			if (this.hasSetEmail || (this.form.email && !this.customer.email)){
				this.hasSetEmail = true;
				this.$store.commit('setCustomer', {
					email: this.form.email
				});
			}
			const url = Api.returnPromoCodeURL(
				this.form.code, 
				this.dealer.dealerID, 
				this.vehicle.materialCode, 
				this.vehicle.vehicleSpecificationID, 
				this.vehicle.batchNumber, 
				this.form.email
			);
			axios.get(url).then((response: any) => {
				Helpers.clog(response);
				let promoTypeName = '(not set)';
				if (response.data.Valid){
					Analytics.sendEvent({
						"event":"applyReferenceCode",
						"transaction": {
							"referenceCode" : this.form.code,
							"referenceCodeStatus" : "Success"
						}
					});
					switch (response.data.PromoType) {
						case 1:
							promoTypeName = 'Discount';
						break
						case 2:
							promoTypeName = 'Confirmed Trade';
						break
						case 3:
							promoTypeName = 'Value Add';
						break
					}
					const promoData = {
						...response.data,
						PromoTypeName: promoTypeName,
						Code: this.form.code,
						Email: this.form.email, 
						DiscSymbol: '[&sect;]'
					};
					this.$store.commit('setPromoCode', promoData);
					this.confirmPromoCode();
					this.emailRequired = false;
					this.emailError = false;
					this.invalid = false;
					this.errorMsg = '';
				} 
				else if (response.data.NeedsAuth){
					Analytics.sendEvent({
						"event":"applyReferenceCode",
						"transaction": {
							"referenceCode" : this.form.code,
							"referenceCodeStatus" : 'Thanks, please confirm your email address.'
						}
					});
					this.emailRequired = true;
					this.invalid = false;
					this.errorMsg = '';
					this.emailError = !!this.form.email;
				} 
				else {
					Analytics.sendEvent({
						"event":"applyReferenceCode",
						"transaction": {
							"referenceCode" : this.form.code,
							"referenceCodeStatus" : response.data.ErrorMsg == 'Reference Number not found' ? 'Invalid Code' : response.data.ErrorMsg
						}
					});
					this.emailError = false;
					this.emailRequired = false;
					this.invalid = true;
					this.form.code = '';
					this.errorMsg = response.data.ErrorMsg;
				}
				this.$store.dispatch('removeDisclaimer', 'promoCode');
				this.$store.commit('addDisclaimer', {
					type: "promoCode", 
					for: 'promoCode',
					key: '[&sect;]',
					text: this.promoCode.Disc
				});
				this.isProcessing = false;
			}).catch((error: any) => {
				Helpers.clog(error);
				this.$store.commit('setError', {
					message: `There was a problem with our system. Please try again later.`
				});
				this.isProcessing = false;
			});
		}, 
		confirmPromoCode(): void {
			this.$store.commit('setPromoCode', {
				Applied: true
			});
			if (this.promoCode.PromoType == 1){
				Api.getUpdatedfinance(this);
			}
		}, 
		removePromoCode(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Remove Reference Code"
			});
			const t = this.promoCode.PromoType;
			this.$store.commit('setPromoCode', {
				Applied: false,
				Code: '',
				Description: '',
				Email: '',
				NeedsAuth: false,
				SysDesc: '',
				PromoType: 0,
				Valid: false,
				PromoValue: '',
				ValueDesc: '', 
				Disc: '', 
				DiscSymbol: ''
			});
			this.$store.dispatch('removeDisclaimer', 'promoCode');
			this.form.email = '';
			this.form.code = '';
			this.errorMsg = '';
			this.emailRequired = false; 
			this.emailError = false;
			this.invalid = false;
			if (t == 1){
				Api.getUpdatedfinance(this);
			}
		}
	}, 
	mounted(): void {
		this.form.email = this.customer.email;
	}
});
